// extracted by css-extract-rspack-plugin
export default {"row":"row-NgRcUQ","td":"td-InOr6R","selectedRow":"selectedRow-XrzWgJ"};